import { app } from '../../../app';

app.component('userPublic', {
    templateUrl: require('./public.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/public.component.js